export const backend_url = "https://merchmind-backend-production.up.railway.app"


export const server = "https://merchmind-backend-production.up.railway.app/api/v2"